import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { api, pickDto } from '@/shared/api';
import { Telegram } from '@synapex/shared2/gateway-rest-api';

//query
export const useTmeInfoQuery = <SelectedData = Telegram.PeerTmeInfoReply>(
  peer: Telegram.PeerReferenceInputDto | null,
  options?: Omit<
    UseQueryOptions<Telegram.PeerTmeInfoReply, Error, SelectedData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const disabled = options?.enabled === false;
  const params = peer ? pickDto(Telegram.PeerReferenceInputDto, peer) : {};
  // console.log({ peer, params, disabled })
  const query = useQuery({
    ...options,
    enabled: Boolean(params.username || params.invite_hash) && !disabled,
    queryKey: ['tme-info', params],
    queryFn: () => {
      return api.get<Telegram.PeerTmeInfoReply>(`telegram-2/tme-info`, {
        params,
      });
    },
  });

  return query;
};
